import { useContext } from "react";
import { RadioGroupContext } from "./RadioGroupContext";

type PropsWithValue<T> = T & { value?: string | number };

export const useRadioProps = <T extends object>(props: PropsWithValue<T>) => {
  const context = useContext(RadioGroupContext);

  if (!context) {
    return props;
  }

  const { name, value, defaultValue, onChange } = context;

  return {
    ...props,
    onChange,
    name,
    ...(typeof value !== "undefined" && { checked: props.value === value }),
    ...(typeof defaultValue !== "undefined" && {
      defaultChecked: props.value === defaultValue,
    }),
  };
};
